// Favicon dinámico por superficie: Booster (casita) en el CRM, Imperium en el
// público. El de Booster es un SVG inline (no requiere asset) que matchea el
// monograma del lockup BoosterMark. El color sale de la paleta de marca.
import { getCrmPalette } from '../theme/brand';

const ACCENT = getCrmPalette().brand.golden;
const ON     = getCrmPalette().brand.onAccent; // contraste sobre el acento sólido

export const BOOSTER_FAVICON =
  'data:image/svg+xml,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">` +
      `<rect width="32" height="32" rx="7" fill="${ACCENT}"/>` +
      `<path d="M7 15 L16 8 L25 15" fill="none" stroke="${ON}" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>` +
      `<path d="M7 20 L16 13 L25 20" fill="none" stroke="${ON}" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>` +
      `<path d="M7 20 L7 25.5" fill="none" stroke="${ON}" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>` +
      `<path d="M25 20 L25 25.5" fill="none" stroke="${ON}" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>` +
    `</svg>`,
  );

export const IMPERIUM_FAVICON = '/favicon-32.png';

/** Setea (o crea) el favicon de la app. SVG inline o ruta a PNG. */
export function setFavicon(href: string) {
  let link = document.querySelector<HTMLLinkElement>('link#app-favicon');
  if (!link) {
    link = document.createElement('link');
    link.id = 'app-favicon';
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.type = href.startsWith('data:image/svg') ? 'image/svg+xml' : 'image/png';
  link.href = href;
}
